var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQuotes = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "m1.426 21 3.922-7.971h-.086c-1.136 0-2.13-.407-2.983-1.22C1.426 10.995 1 9.965 1 8.718c0-1.356.483-2.468 1.45-3.335C3.471 4.46 4.722 4 6.2 4c1.478 0 2.7.46 3.666 1.383 1.023.922 1.534 2.033 1.534 3.335 0 .813-.142 1.6-.426 2.359-.227.705-.54 1.464-.938 2.277L6.286 21h-4.86Zm12.6 0 3.921-7.971h-.085c-1.136 0-2.131-.407-2.984-1.22-.852-.814-1.278-1.844-1.278-3.091 0-1.356.483-2.468 1.449-3.335C16.072 4.46 17.322 4 18.799 4c1.479 0 2.7.46 3.666 1.383C23.488 6.305 24 7.416 24 8.718c0 .813-.142 1.6-.426 2.359-.228.705-.54 1.464-.938 2.277L18.886 21h-4.86Z",
  fill: "currentColor",
  fillRule: "nonzero"
}))));
export default SvgQuotes;